import '../../styles/footer.scss';

const footerNavEl = document.querySelector('.footer .nav');

footerNavEl.addEventListener('click', (event) => {
  const { target } = event;
  if (target.classList.contains('link-title') || target.classList.contains('plus')) {
    event.stopPropagation();

    footerNavEl.querySelectorAll('.link-group').forEach((el) => {
      if (el === target.parentNode) {
        el.classList.toggle('active');
      } else {
        el.classList.remove('active');
      }
    });
  }
});

document.querySelectorAll('.facebook.link').forEach((el) => {
  const facebookIconTemplateEl = document.querySelector('#facebook-icon');
  const instance = document.importNode(facebookIconTemplateEl.content, true);
  el.prepend(instance);
});

document.querySelectorAll('.instagram.link').forEach((el) => {
  const instagramIconTemplateEl = document.querySelector('#instagram-icon');
  const instance = document.importNode(instagramIconTemplateEl.content, true);
  el.prepend(instance);
});

document.querySelectorAll('.pinterest.link').forEach((el) => {
  const pinterestIconTemplateEl = document.querySelector('#pinterest-icon');
  const instance = document.importNode(pinterestIconTemplateEl.content, true);
  el.prepend(instance);
});

if (!window.theme.isWholesale) {
  document
    .querySelector('#activate-form-cta')
    .addEventListener('click', (event) => {
      document.querySelector('.footer__top').classList.add('active');
    });
}
